import { render, staticRenderFns } from "./VenueHireTable.vue?vue&type=template&id=3fa80577&scoped=true&"
import script from "./VenueHireTable.vue?vue&type=script&lang=js&"
export * from "./VenueHireTable.vue?vue&type=script&lang=js&"
import style0 from "./VenueHireTable.vue?vue&type=style&index=0&id=3fa80577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa80577",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
